import styles from './BrandMark.module.css';

/**
 * The brand mark: a 3x3 mini-grid in an outlined rounded square, two cells tinted.
 * A CSS grid rather than an image, as the handoff specifies.
 */
export function BrandMark(): React.JSX.Element {
  // Cells 1 and 5 (0-indexed) carry the accent tint, matching the mockups.
  const tinted = new Set([1, 5]);

  return (
    <div className={styles.mark} aria-hidden="true">
      {Array.from({ length: 9 }, (_, i) => (
        <span key={i} className={tinted.has(i) ? styles.tinted : undefined} />
      ))}
    </div>
  );
}
